import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ExternalLendersIntroComponent } from './external-lenders-intro/external-lenders-intro.component';
import { ExternalLendersPartnerComponent } from './external-lenders-partner/external-lenders-partner.component';
import { RouterModule, Routes } from '@angular/router';
import { SharedDesktopModule } from '@brightside-web/shared/desktop';
import { BrightsideUiModule } from '@brightside/brightside-ui';
import { TranslateModule } from '@ngx-translate/core';
import { MicroUiMoleculeModule } from '@micro-ui/molecule';
import { ExternalPartnerService } from '@brightside-web/desktop/data-access/shared';
import { ExternalLendersLegalComponent } from './external-lenders-legal/external-lenders-legal.component';


const ROUTES: Routes = [
  {
    path: '',
    component: ExternalLendersIntroComponent,
  },
  {
    path: ':lenderKey',
    children: [
      {
        path: 'info',
        component: ExternalLendersPartnerComponent,
      },
      {
        path: 'legal',
        component: ExternalLendersLegalComponent
      },
      {
        path: '**',
        redirectTo: 'legal',
      }
    ]
  },
];

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(ROUTES),
    SharedDesktopModule,
    BrightsideUiModule,
    TranslateModule,
    MicroUiMoleculeModule,
  ],
  declarations: [ExternalLendersIntroComponent, ExternalLendersPartnerComponent],
  providers: [ExternalPartnerService],
})
export class DesktopFeatureExternalLendersModule {}
